import Input from '@uilib/business-components/Input';

import i18n from 'Services/i18n';

export default function InputWrapper(props) {
    return <Input {...props} placeholder={i18n(props.placeholder)} />;
}
